import React, { useState, useEffect } from "react";
import "./Votes.scss"
import Items from "../Items/Items.jsx";
import data from '../../static/data/data.json';
import ItemsList from "../ItemsList/ItemsList";
import Loader from '../Loader/Loader';
import ThanksModal from '../ThanksModal/ThanksModal';
import { isMobile, isIos } from '../../static/helper';
import Header from "../Header/Header";
import { virtualPageView } from "../Analytics/Analytics";

const getShuffleData = (array) => {
  Object.keys(array).map((item, i) => {
    for (let i = array[item].length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * i)
      const temp = array[item][i]
      array[item][i] = array[item][j]
      array[item][j] = temp
    }
  })
  return array;
}


const Votes = (props) => {
  const [isDataShuffled, setisDataShuffled] = useState(false);
  const [dataShuffled, setData] = useState(data);
  const [isResultsDisplay, setResultsDisplay] = useState(false);
  const categories = [
    {
      category: "movies",
      title: "סרטים"
    },
    {
      category: "series",
      title: "סדרות"
    },
    {
      category: "songs",
      title: "שירים"
    }
  ]
  const [currentCategory, setCategory] = useState(categories[0].category);
  const [selectedItems, setSelectedItems] = useState({})
  const [currentCategoryIndex, setCategoryIndex] = useState(0);
  const [isThanksModalDisplay, setIsThanksModalDisplay] = useState(false);
  const [isLoaderActive, setisLoaderActive] = useState(false);

  useEffect(() => {
    if (currentCategoryIndex > -1 && currentCategoryIndex < categories.length) {
      window.scrollTo(0, 0);
      virtualPageView(`https://decadeparade.ynet.co.il/pick_${categories[currentCategoryIndex].category}`, `Pick ${categories[currentCategoryIndex].category}`)
      if (selectedItems[categories[currentCategoryIndex].category] && selectedItems[categories[currentCategoryIndex].category].length === 3) {
        setCategoryIndex(currentCategoryIndex);
        setCategory(categories[currentCategoryIndex].category);
        setResultsDisplay(false);
        return;
      }
      setisLoaderActive(true);
      setCategory(categories[currentCategoryIndex].category);
      setTimeout(() => {
        setisLoaderActive(false);
      }, 300);
    }
    else {
      console.log(selectedItems);
      setResultsDisplay(true);
    }
  }, [currentCategoryIndex])

  const postData = async (token, callback) => {
    // window.grecaptcha.reset();
    var res = await fetch(
      // `http://localhost:53574/api/home`
      // `https://qa-a.ynet.co.il/mshort/content/DecadeParade/API/api/home`
      `https://z.ynet.co.il/mshort/content/DecadeParade/API/api/home`
      , {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(selectedItems)
      }).then(dataJS => {
        // var t = dataJS.text();
        return dataJS.json();
      });
    onCallback(res);
  }

  const onCallback = (res) => {
    if (res === "success") {
      setisLoaderActive(false);
      localStorage.setItem("dpaevfv_teu", true);
      if (isMobile() || isIos()) {
        props.setPageSection("thanks");
      }
      else {
        setIsThanksModalDisplay(true);
      }
    }
  }

  const checkItems = (items) => {
    let res = -1;
    categories.map((category, i) => {
      if (res === -1 && ((items[category.category] && items[category.category].length < 3) || !items[category.category])) {
        res = i;
      }
    });
    return res;
  }

  const setItem = (item, e, specificCategory, specificCategoryIndex) => {
    if (e && e.target.className.indexOf("play") > -1) return;
    let selectedItemsClone = { ...selectedItems };
    let category = specificCategory || currentCategory;
    let categoryIndex = specificCategoryIndex || currentCategoryIndex;
    let currentItems = selectedItemsClone[category]
    if (currentItems) {
      if (currentItems.some(x => x.id === item.id)) {
        selectedItemsClone[category] = currentItems.filter(x => x.id !== item.id);
      }
      else if (currentItems.length <= 2) {
        selectedItemsClone[category] = [...currentItems, item];
      }
      if (selectedItemsClone[category].length === 3) {
        let notFinish = checkItems(selectedItemsClone);
        if (notFinish !== -1) {
          setCategoryIndex(notFinish);
        }
        else {
          setCategoryIndex(-1);
          setResultsDisplay(true);
        }
      }
    }
    else {
      selectedItemsClone[category] = [item]
    }

    setSelectedItems(selectedItemsClone);
  }

  useEffect(() => {
    if (typeof data !== 'undefined' && !isDataShuffled) {
      setData(getShuffleData(data));
      setisDataShuffled(true);
    }

  }, [isDataShuffled])

  return (
    <>
      <Header
        setPageSection={props.setPageSection}
        isResultsDisplay={isResultsDisplay}
        currentCategoryIndex={currentCategoryIndex}
        isResultsDisplay={isResultsDisplay}
        categories={categories}
        currentCategory={currentCategory}
        selectedItems={selectedItems}
        setCategory={setCategoryIndex}
        categoryIndex={currentCategoryIndex}
        class="fixed" />

      <Loader active={isLoaderActive} />
      <div className="votes-container">
        {isDataShuffled === true && !isResultsDisplay ?
          <Items categoryIndex={currentCategoryIndex} setItem={setItem} selectedItems={selectedItems} currentCategory={currentCategory} data={dataShuffled} />
          : isResultsDisplay ?
            <>
              {
                isThanksModalDisplay ?
                  <ThanksModal onClickHandle={() => props.setPageSection("home")} />
                  : ""
              }
              <ItemsList setisLoaderActive={setisLoaderActive} setPageSection={props.setPageSection} setResultsDisplay={setResultsDisplay} categories={categories} selectedItems={selectedItems} postData={postData} setCategory={setCategoryIndex} setItem={setItem} />
            </>
            : ""
        }
      </div>
    </>
  );
}

export default Votes;
